export default "__VITE_ASSET__C7Eo_1WU__"